class Utils {
    static getAccessToken() {
        // return window.localStorage.getItem("accessToken");
        const accessToken = localStorage.getItem('accessToken')
        return accessToken;
    }

    static logoutUser() {
        const roleId = localStorage.getItem('RoleId');
        let roleType = '';

        if (roleId == "8") {
            roleType = '/auth/tenvic-student';
        } else if (roleId == "7") {
            roleType = '/auth/tenvic-institution';
        } else {
            roleType = '/auth/tenvic-login';
        }
        localStorage.clear();
        window.location.href = roleType;
    }
}

export default Utils;